var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,7l-4,4,1.4,1.4,1.6-1.6v4.2h2v-4.2l1.6,1.6,1.4-1.4-4-4ZM2,5v11h14V5H2ZM2,18c-.55,0-1.02-.2-1.41-.59C.2,17.02,0,16.55,0,16V3.52C0,3.29.04,3.07.11,2.85s.19-.42.34-.6L1.7.72c.18-.23.41-.41.69-.54S2.95,0,3.25,0h11.5C15.05,0,15.34.06,15.61.19s.5.3.69.54l1.25,1.53c.15.18.26.38.34.6s.11.44.11.68v12.48c0,.55-.2,1.02-.59,1.41-.39.39-.86.59-1.41.59H2ZM2.4,3h13.2l-.85-1H3.25l-.85,1Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUpload);
export default __webpack_public_path__ + "static/media/bulk_upload.8f9a320f9844717981c71e6b7a18ade0.svg";
export { ForwardRef as ReactComponent };